/// <reference path="./../index.d.ts" />

import { createApp } from 'vue'
import { createStore as _createStore } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'

import App from "./App.vue";
import { storeOptions } from "../common/vuex";
import { Routes } from "./routes";


const store = _createStore(storeOptions);

const router = createRouter({
	history: createWebHistory(),
	routes: Routes,
    scrollBehavior: () => ({ top: 0 }),
});


var gcui_dfw_video = {};

(function() {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', "/api/i18n?group=gcui_dfw_video", true);
  xhr.responseType = 'json';
  xhr.onload = function() {
	gcui_dfw_video = xhr.response;
	loadVideoChannel();
  };
  xhr.send();
})();


function loadVideoChannel() {
	const locale = document.documentElement.lang;
	const i18n = createI18n({
		locale,
		messages: {
			[locale]: { gcui_dfw_video },
		},
	});
	
	// Initialize vue component.
	var app = createApp({
		extends: App,
	}, document.querySelector("#videos").dataset)
	.use(i18n)
	.use(store)
	.use(router);

	app.mount("#videos");
}
